import * as types from '@/store/mutation-types'

export default {
	namespaced: true,
	state: {
		auditLogs: [],
		users: []
	},

	actions: {
		fetchAll(_, { logType, fromDate, toDate, financialFileId, userId, page, perPage }) {
			return window.axios.get('/Logs/Audit/filter', {
				params: {
					logType,
					fromDate, 
					toDate,
					nonDeleted: false,
					financialFileId,
					userId,
					orderByCreatedAt: true,
					page,
					perPage
				}
			}).then((response) => {
				return { total: +response.headers['x-pagination-total-count'], items: response.data }
			})
		},
		fetchAuditData(_, { entityId, type }) {
			return window.axios.get(`/Logs/Audit/entity/${entityId}/${type}`).then(({ data }) => {
				return data;
			})
		}
	},

	mutations: {
		[types.STORE_AUDIT_LOGS](state, auditLogs) {
			state.auditLogs = auditLogs
		},
	},

	getters: {
	}
}
